@if (kicker(); as label) {
  <span class="vp-notification-meta__kicker" data-testid="notification-kicker">{{ label }}</span>
}
@if (locked()) {
  <vp-status-pill variant="urgent" data-testid="notification-urgent">Urgent</vp-status-pill>
} @else if (notification().resolved) {
  <vp-status-pill variant="completed" data-testid="notification-cleared">{{
    clearedLabel()
  }}</vp-status-pill>
}
@if (notification().kind !== "call-light" && notification().kind !== "call-light-urgent") {
  @if (activeSince() !== null) {
    <span data-testid="notification-active">
      Active <span class="vp-notification-meta__timer" [vpLiveTimer]="activeSince()"></span>
    </span>
  } @else {
    <span data-testid="notification-time">{{ notification().createdAt | date: "h:mm a" }}</span>
  }
}
